'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactClass = require('react-class');

var _reactClass2 = _interopRequireDefault(_reactClass);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _reactFlex = require('react-flex');

var _join = require('./join');

var _join2 = _interopRequireDefault(_join);

var _bemFactory = require('./bemFactory');

var _bemFactory2 = _interopRequireDefault(_bemFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLASS_NAME = 'react-tab-panel__body';

var bem = (0, _bemFactory2.default)(CLASS_NAME);
var m = function m(name) {
  return bem(null, name);
};

var Body = function (_Component) {
  _inherits(Body, _Component);

  function Body() {
    _classCallCheck(this, Body);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Body).apply(this, arguments));
  }

  _createClass(Body, [{
    key: 'render',
    value: function render() {
      var props = this.props;


      var className = (0, _join2.default)(props.className, CLASS_NAME, m('tab-position-' + props.tabPosition), m('orientation-' + (props.vertical ? 'vertical' : 'horizontal')), props.transition && m('transition'), props.transitioning && props.transitioning !== true && m('transition-' + (props.transitioning == -1 ? 'prev' : 'next')), props.transitionInProgress && m('transitioning'));

      var content = props.renderContent(props.children);

      return _react2.default.createElement(_reactFlex.Flex, _extends({
        row: true,
        wrap: false,
        alignItems: 'start',
        flex: 'none'
      }, props, {
        className: className,
        children: content
      }));
    }
  }]);

  return Body;
}(_reactClass2.default);

exports.default = Body;


Body.propTypes = {
  renderContent: _react.PropTypes.func
};

Body.defaultProps = {
  renderContent: function renderContent(children) {
    return children;
  },
  isTabBody: true
};


//////////////////
// WEBPACK FOOTER
// ./~/react-tab-panel/lib/Body.js
// module id = 1890
// module chunks = 0